// extracted by mini-css-extract-plugin
module.exports = {"card":"RoundCard_card__ZLcZS","row":"RoundCard_row__1gtS6","title":"RoundCard_title__1rjU-","line":"RoundCard_line__HohHF"};